import * as Types from '../../../../../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RecordApplyStartMutationVariables = Types.Exact<{
  input: Types.RecordApplyStartInput;
}>;


export type RecordApplyStartMutation = { __typename?: 'Mutation', recordApplyStart?: { __typename?: 'RecordApplyStartPayload', jobResultTrackingKey: string } | null };

export type RecordApplyCompleteMutationVariables = Types.Exact<{
  input: Types.RecordApplyCompleteInput;
}>;


export type RecordApplyCompleteMutation = { __typename?: 'Mutation', recordApplyComplete?: { __typename?: 'RecordApplyCompletePayload', jobResultTrackingKey: string } | null };


export const RecordApplyStartDocument = gql`
    mutation RecordApplyStart($input: RecordApplyStartInput!) {
  recordApplyStart(input: $input) {
    jobResultTrackingKey
  }
}
    `;
export type RecordApplyStartMutationFn = Apollo.MutationFunction<RecordApplyStartMutation, RecordApplyStartMutationVariables>;

/**
 * __useRecordApplyStartMutation__
 *
 * To run a mutation, you first call `useRecordApplyStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordApplyStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordApplyStartMutation, { data, loading, error }] = useRecordApplyStartMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordApplyStartMutation(baseOptions?: Apollo.MutationHookOptions<RecordApplyStartMutation, RecordApplyStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordApplyStartMutation, RecordApplyStartMutationVariables>(RecordApplyStartDocument, options);
      }
export type RecordApplyStartMutationHookResult = ReturnType<typeof useRecordApplyStartMutation>;
export type RecordApplyStartMutationResult = Apollo.MutationResult<RecordApplyStartMutation>;
export type RecordApplyStartMutationOptions = Apollo.BaseMutationOptions<RecordApplyStartMutation, RecordApplyStartMutationVariables>;
export const RecordApplyCompleteDocument = gql`
    mutation RecordApplyComplete($input: RecordApplyCompleteInput!) {
  recordApplyComplete(input: $input) {
    jobResultTrackingKey
  }
}
    `;
export type RecordApplyCompleteMutationFn = Apollo.MutationFunction<RecordApplyCompleteMutation, RecordApplyCompleteMutationVariables>;

/**
 * __useRecordApplyCompleteMutation__
 *
 * To run a mutation, you first call `useRecordApplyCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordApplyCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordApplyCompleteMutation, { data, loading, error }] = useRecordApplyCompleteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordApplyCompleteMutation(baseOptions?: Apollo.MutationHookOptions<RecordApplyCompleteMutation, RecordApplyCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordApplyCompleteMutation, RecordApplyCompleteMutationVariables>(RecordApplyCompleteDocument, options);
      }
export type RecordApplyCompleteMutationHookResult = ReturnType<typeof useRecordApplyCompleteMutation>;
export type RecordApplyCompleteMutationResult = Apollo.MutationResult<RecordApplyCompleteMutation>;
export type RecordApplyCompleteMutationOptions = Apollo.BaseMutationOptions<RecordApplyCompleteMutation, RecordApplyCompleteMutationVariables>;